/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { NetworkInterfaceInfo } from "./NetworkInterfaceInfo";
import {
    NetworkInterfaceInfoFromJSON,
    NetworkInterfaceInfoFromJSONTyped,
    NetworkInterfaceInfoToJSON,
} from "./NetworkInterfaceInfo";

/**
 *
 * @export
 * @interface DeviceConnectionInfoResponse
 */
export interface DeviceConnectionInfoResponse {
    /**
     *
     * @type {string}
     * @memberof DeviceConnectionInfoResponse
     */
    deviceIdentity?: string;
    /**
     *
     * @type {Array<NetworkInterfaceInfo>}
     * @memberof DeviceConnectionInfoResponse
     */
    networkInterfaces?: Array<NetworkInterfaceInfo>;
}

/**
 * Check if a given object implements the DeviceConnectionInfoResponse interface.
 */
export function instanceOfDeviceConnectionInfoResponse(
    value: object,
): value is DeviceConnectionInfoResponse {
    return true;
}

export function DeviceConnectionInfoResponseFromJSON(
    json: any,
): DeviceConnectionInfoResponse {
    return DeviceConnectionInfoResponseFromJSONTyped(json, false);
}

export function DeviceConnectionInfoResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceConnectionInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        networkInterfaces:
            json["networkInterfaces"] == null
                ? undefined
                : (json["networkInterfaces"] as Array<any>).map(
                      NetworkInterfaceInfoFromJSON,
                  ),
    };
}

export function DeviceConnectionInfoResponseToJSON(
    value?: DeviceConnectionInfoResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        networkInterfaces:
            value["networkInterfaces"] == null
                ? undefined
                : (value["networkInterfaces"] as Array<any>).map(
                      NetworkInterfaceInfoToJSON,
                  ),
    };
}
